import React, {Component} from 'react';
import Project from './project.component';

export default class Customer extends Component{
    render(){
        return(
            <section>
                {this.props.headline &&
                <h2>{this.props.customer.name}</h2>
                }
                {Object.entries(this.props.customer.projects).map(([key,project]) => {
                    return (
                        <Project 
                            key={key}
                            base={this.props.base}
                            customer={this.props.customer}
                            project={project}
                            onClick={() => this.props.selectObject(project)}
                            selected={this.props.selected}
                        />
                    );
                })}        
            </section>
        );
    }
}


// WEBPACK FOOTER //
// ./src/js/overview/components/customer.component.js